import { IS_APPLE } from '../../constants/os';

const AppleKeys = [
  { from: 'Ctrl', to: '⌘' },
  { from: 'Alt', to: 'Opt' },
];

function normalizeShortcut(shortcut: string) {
  let normalizedShortcut = shortcut;
  if (normalizedShortcut && IS_APPLE) {
    AppleKeys.forEach(({ from, to }) => {
      normalizedShortcut = normalizedShortcut?.replace(from, to);
    });
  }

  return normalizedShortcut;
}

export default normalizeShortcut;
